import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Button, Paper, TextField, IconButton, Autocomplete, Chip, Box, Dialog,
  DialogTitle, Tooltip,
  DialogContent } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import Swal from 'sweetalert2';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from '@mui/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import BtnAcciones from '../../components/plantilla/tabla/BtnAcciones';
import Draggable from 'react-draggable';
import dayjs from 'dayjs';

import { AgGridReact } from 'ag-grid-react';

// Modales
import CrearEditarModal from './modales/CrearEditarResetUsa';
import ColorLegendDialog from './modales/ColorLegendDialog2';

// Iconos
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ListIcon from '@mui/icons-material/List';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
}

const Cargas_Omni = () => {

    const [open, setOpen] = useState(false);
    const [fileUrl, setFileUrl] = useState('');
    const [isPdf, setIsPdf] = useState(false);
    const [isImage, setIsImage] = useState(false);
    const [Titulo, setTitulo] = useState('');

    const handleFileClick = (fileName) => 
    {
        const extension = fileName.split('.').pop().toLowerCase();
        const isPdfFile = extension === 'pdf';
        const isImageFile = ['jpg', 'jpeg', 'png', 'gif'].includes(extension);

        const mimeType = isPdfFile ? 'application/pdf' : isImageFile ? `image/${extension === 'jpg' ? 'jpeg' : extension}` : '';

        myApi.get(`fuel_report/pdf/${encodeURIComponent(fileName)}`, { responseType: 'arraybuffer' })
        .then((response) => {
            const blob = new Blob([response.data], { type: mimeType });
            const url = window.URL.createObjectURL(blob);
            setIsPdf(isPdfFile); 
            setIsImage(isImageFile);
            setFileUrl(url);
            setOpen(true);
        })
        .catch((error) => {
            console.error('Error al cargar el PDF:', error);
        });
    };

    const handleOpenDialog = (params, isPdf = 1, nombre_col = '', titulo = '', numero = null) => 
    {
        setTitulo(titulo);
        if(isPdf)
            handleFileClick(params.pdf);
    };

    const handleCloseDialog = () => 
    {
        setOpen(false);
    };

    const [openLegend, setOpenLegend] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const { info } = location.state || {};

    useEffect(() => {
        window.scrollTo(0, 0);

        if (!info) return; 

        let objeto;
        try 
        {
            objeto = typeof info === "string" ? JSON.parse(info) : info;
        } 
        catch (e) 
        {
            console.error("info inválido:", info, e);
            return;
        }

        const sd = objeto?.startDate ? dayjs(objeto.startDate) : null;
        const ed = objeto?.endDate ? dayjs(objeto.endDate) : null;

        const unidadPayload = objeto?.unit ?? null;
        const operadorPayload = Array.isArray(objeto?.driver)
            ? objeto.driver
            : objeto?.driver ? [objeto.driver] : [];

        setStartDate(sd);
        setEndDate(ed);
        setUnit(unidadPayload ?? '');
        setDriver(operadorPayload);

        const fi = sd ? sd.format("YYYY-MM-DD") : null;
        const ff = ed ? ed.format("YYYY-MM-DD") : null;

        fetchData(unidadPayload, fi, ff, operadorPayload);
    }, [info]);

    const [selected, setSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleOpenModal = (carga = null) => 
    {
        setSelected(carga);
        setIsEditing(!!carga);
        setModalOpen(true);
    };

    const handleEdit = useCallback(async (fuelRow) => {
        handleOpenModal(data.find(carga => carga.id === fuelRow.id));
        setIsEditing(true);
        setSelected(fuelRow);
    }, []);

    const handleDelete = useCallback(async (id) => 
    {
        try 
        {
            Swal.fire({
                title: '¿Estás seguro de eliminar este reset?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
            }).then(async (result) => 
            {
            
                if (result.isConfirmed) 
                {
                    let { data } = await myApi.delete(`/cargasFuel/deleteResetUsa/${id}`);

                    if (data.success) 
                    {
                        Swal.fire({
                            icon: 'success',
                            title: 'Reset eliminado',
                        });

                        setData(prevData => prevData.filter(carga => carga.id !== id));
                    } 
                    else 
                    {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al eliminar el reset',
                        });
                    }
                }
            });
        } 
        catch (error) 
        {
            console.error('Error deleting reset:', error);
        }
    }, []);

    const [data, setData] = useState([]);

    const useStyles = makeStyles({
        locationLaredo: {
            backgroundColor: "#073763 !important", 
            color: "#fff",
            fontWeight: "bold"
        },
        locationColombia: {
            backgroundColor: "#fff2cc !important",
            color: "#000",
            fontWeight: "bold"
        },
        cellPurple: {
            backgroundColor: "#9c27b0 !important",
            color: "#fff",
            fontWeight: "bold"
        },
        rowBlue: {
            backgroundColor: "#4A86E8 !important",
            color: "white",
        },
        cellBrightGreen: {
            backgroundColor: "#00FF00 !important",
            color: "#000",
            fontWeight: "bold"
        },
        cellYellow: {
            backgroundColor: "#FFFF00 !important",
            color: "#000",
            fontWeight: "bold"
        },
        cellRed: {
            backgroundColor: "#FF0000 !important",
            color: "#fff",
            fontWeight: "bold"
        }
    });

    const classes = useStyles();

    const parseNumber = (value) => 
    {
        if (value === null || value === undefined || value === '') return null;
        if (value === '-') return '-';
        const num = Number(value.toString().replace(/,/g, ''));
        return isNaN(num) ? null : num;
    };

    const [loading, setLoading] = useState(false);

    const [unit, setUnit] = useState(''); // Estado para el campo "Unidad"
    const [startDate, setStartDate] = useState(null); // Estado para la fecha inicial
    const [endDate, setEndDate] = useState(null); // Estado para la fecha final

    const [driver, setDriver] = useState([]);

    const [operadores, setOperadores] = useState([]);

    // Maneja los cambios en el campo "Unidad"
    const handleChangeUnidad = (event) => {
        setUnit(event.target.value);
    };

    // Maneja los cambios en la fecha de inicio
    const handleChangeStartDate = (newValue) => {
        setStartDate(newValue);
        // Si la fecha final ya está establecida y es menor a la fecha inicial, la actualizamos
        if (endDate && newValue.isAfter(endDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha inicial no puede ser mayor que la fecha inicial.',
            }).then(() => {
                setEndDate(newValue);
            }); 
                // Establecer la fecha final igual a la fecha inicial
        }
    };

    // Maneja los cambios en la fecha de fin
    const handleChangeEndDate = (newValue) => {
        setEndDate(newValue);
        if (startDate && newValue.isBefore(startDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha final no puede ser menor que la fecha inicial.',
            }).then(() => {
                setEndDate(startDate);
            }); 
        }
    };

    // Handler para vaciar la fecha al hacer clic
    const handleClearDate = (fecha) => {
        if(fecha === 'fi')
            setStartDate(null); 
        else if (fecha === 'ff')
            setEndDate(null); 
    };

    //Función para formatear la fecha
    const formatDate = (date) => {
        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
    
        // Formato deseado: MM/DD/YY HH:mm
        const [datePart, timePart] = formattedDate.split(', '); // Separar fecha y hora
        const [month, day, year] = datePart.split('/'); // Separar mes, día y año
        //const formattedDateTime = `${month}/${day}/${year} ${timePart.slice(0, 5)}`; // Construir el formato
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`; // Construir el formato
    
        return formattedDateTime;
    };

    const columns = [
        {
            field: 'date', headerName: 'Reset Date',
            headerAlign: "center",
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => {
                if (!params.value) return '';

                return formatDate(params.value); 
            },
            
        },
        {
            field: 'driver', headerName: 'Driver',
            headerAlign: "center",
            cellStyle: { textAlign: "center" },
        },
        {
            field: 'vehicleIds', headerName: 'Vehicle(s)',
            headerAlign: "center",
            cellStyle: { textAlign: "center" },
        },
        {
            field: 'MILLAS', headerName: 'Total Distance',
            headerAlign: "center",
            cellStyle: { textAlign: "right" },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined || params.value === '') 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            }
        },
        {
            field: 'FUEL_USED', headerName: 'Total Fuel',
            headerAlign: "center",
            cellStyle: { textAlign: "right" },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined || params.value === '') 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
        },
        {
            field: 'MPG', headerName: 'MPG',
            headerAlign: "center",
            cellStyle: { textAlign: "right" },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined || params.value === '') 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            cellClassRules: 
            {
                [classes.cellBrightGreen]: (params) => 
                {
                    if (params.data?.INICIAL === 1) return false;
                    const mpg = parseNumber(params.value);
                    const goal = parseNumber(params.data?.MPG_GOAL);
                    if (mpg === null || goal === null) return false;
                    return mpg >= goal; // VERDE
                },

                [classes.cellYellow]: (params) => {
                    if (params.data?.INICIAL === 1) return false;
                    const mpg = parseNumber(params.value);
                    const goal = parseNumber(params.data?.MPG_GOAL);
                    if (mpg === null || goal === null) return false;
                    return mpg < goal && mpg > (goal - 1);
                },

                [classes.cellRed]: (params) => {
                    if (params.data?.INICIAL === 1) return false;
                    const mpg = parseNumber(params.value);
                    const goal = parseNumber(params.data?.MPG_GOAL);
                    if (mpg === null || goal === null) return false;
                    return mpg <= (goal - 1);
                },
            },
        },
        {
            field: 'IDLE_PER', headerName: 'Idle',
            headerAlign: "center",
            cellStyle: { textAlign: "right" },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined || params.value === '') 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %';;
            },
            valueGetter: (params) => 
            {
                const raw = params.data?.IDLE_PER;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            cellClassRules: 
            {
                [classes.cellBrightGreen]: (params) => {
                if (params.data?.INICIAL === 1) return false;
                const idle = params.value; 
                const goal = parseNumber(params.data?.IDLE_GOAL);
                if (idle == null || goal === null) return false;
                return idle <= 32;
                },

                [classes.cellYellow]: (params) => {
                if (params.data?.INICIAL === 1) return false;
                const idle = params.value; 
                const goal = parseNumber(params.data?.IDLE_GOAL);
                if (idle == null || goal === null) return false;
                return idle > 32 && idle <= 35;
                },

                [classes.cellRed]: (params) => {
                if (params.data?.INICIAL === 1) return false;
                const idle = params.value; 
                const goal = parseNumber(params.data?.IDLE_GOAL);
                if (idle == null || goal === null) return false;
                return idle > 35; 
                },
            },
        },
        {
            field: 'CRUISE_PER', headerName: 'Cruise Ctrl',
            headerAlign: "center",
            cellStyle: { textAlign: "right" },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined || params.value === '') 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %';;
            },
            valueGetter: (params) => 
            {
                const raw = params.data?.CRUISE_PER;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            cellClassRules: {
                [classes.cellBrightGreen]: (params) => {
                if (params.data?.INICIAL === 1) return false;
                const idle = params.value; 
                const goal = parseNumber(params.data?.CRUISE_GOAL);
                if (idle == null || goal === null) return false;
                return idle >= 70;
                },

                [classes.cellYellow]: (params) => {
                if (params.data?.INICIAL === 1) return false;
                const idle = params.value; 
                const goal = parseNumber(params.data?.CRUISE_GOAL);
                if (idle == null || goal === null) return false;
                return idle >= 50 && idle < 70;
                },

                [classes.cellRed]: (params) => {
                if (params.data?.INICIAL === 1) return false;
                const idle = params.value; 
                const goal = parseNumber(params.data?.CRUISE_GOAL);
                if (idle == null || goal === null) return false;
                return idle < 50; 
                },
            },
        },
        {
            field: 'TOPGEAR_PER', headerName: 'Top Gear',
            headerAlign: "center",
            cellStyle: { textAlign: "right" },
            valueFormatter: (params) => 
            {
                if (params.value === null || params.value === undefined || params.value === '') 
                    return ''; 
                const numericValue = Number(params.value.toString().replace(/,/g, ''));
                if (isNaN(numericValue))
                    return params.value;  

                return numericValue.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %';;
            },
            valueGetter: (params) => 
            {
                const raw = params.data?.TOPGEAR_PER;

                if (raw === null || raw === undefined) return null;

                const cleaned = raw
                    .toString()
                    .replace(/,/g, '')
                    .replace('%', '')
                    .trim();

                if (cleaned === '' || cleaned.toUpperCase() === 'NULL') return null;

                const num = Number(cleaned);

                return Number.isFinite(num) ? num : null;
            },
            comparator: (a, b) => {
                if (a == null && b == null) return 0;
                if (a == null) return -1;
                if (b == null) return 1;
                return a - b;
            },
            cellClassRules: {
                [classes.cellBrightGreen]: (params) => {
                if (params.data?.INICIAL === 1) return false;
                const idle = params.value; 
                const goal = parseNumber(params.data?.TOPGEAR_GOAL);
                if (idle == null || goal === null) return false;
                return idle >= 90;
                },

                [classes.cellYellow]: (params) => {
                if (params.data?.INICIAL === 1) return false;
                const idle = params.value; 
                const goal = parseNumber(params.data?.TOPGEAR_GOAL);
                if (idle == null || goal === null) return false;
                return idle >= 80 && idle < 90;
                },

                [classes.cellRed]: (params) => {
                if (params.data?.INICIAL === 1) return false;
                const idle = params.value; 
                const goal = parseNumber(params.data?.TOPGEAR_GOAL);
                if (idle == null || goal === null) return false;
                return idle < 80; 
                },
            },
        },
        {
            field: 'ultima_fecha_hablado',
            headerName: 'Última Plática',
            headerAlign: "center",
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => {
                if (!params.value) return '';
                return formatDate(params.value);
            },
        },
        {
            field: 'dias_desde_ultima_platica',
            headerName: 'Días',
            headerAlign: "center",
            cellStyle: { textAlign: "center" },
            valueFormatter: (params) => {
                if (params.value === null || params.value === undefined) return '';
                return `${params.value} días`;
            },
        },
        {
            headerName: "PDF",headerTooltip: "PDF",
            width: 50,
            field: "pdf",
            //sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            minWidth: 100,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => 
            {
                const row = params.data;
                if(row.pdf)
                {
                    return (
                        <Box>
                            <BtnAcciones
                                icon={<PictureAsPdfIcon />}
                                label={'Abrir PDF'}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenDialog(row, 1, null, 'PDF SUBIDO');
                                }}
                            />
                        </Box>
                    );
                }
            }
        },
/*         {
            headerName: "Actions",headerTooltip: "Actions",
            field: "actions",
            minWidth: 150,
            sortable: false,
            filter: false,
            suppressMenu: true,
            suppressColumnsToolPanel: true,
            cellRenderer: (params) => {
                const row = params.data;
                if (row.isTotal) return null;
                return (
                <div style={{ display: "flex", gap: 8 }}>
                    <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleEdit(params.data);
                    }}
                    />
                    <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(params.data.id);
                    }}
                    />
                </div>
                );
            },
        } */
    ];

    const fetchData = async (unidad = null, fi = null, ff = null, operador = null) => 
    {
        setLoading(true);
        try 
        {
            const datosEnviados = { fi, ff, unidad, operador };
            const response = await myApi.post('/omni/getReporteOmni2', datosEnviados);

            if (response?.data?.success) 
            {
                setData(response.data.rows);
            } 
            else 
            {
                setData([]);
            }
        } 
        catch(error) 
        {
            console.error('Error fetching omni:', error);
            setData([]);
        } 
        finally 
        {
            setLoading(false);
        }
    };
 
    const findOperadores = async () => {
        try {
            const response = await myApi.get('/fuel_report/getOperadores');

            let operadores = [];
            if (response.data.data && response.data.data.length > 0) {
                response.data.data.forEach(operador => {
                    operadores.push({ value: operador.drivercode, label: operador.nombre_completo });
                });
            }
            setOperadores(operadores.length > 0 ? operadores : []); 

        } catch (error) {
            console.error('Error fetching drivers:', error);
            setOperadores([]);
        }
    };

    useEffect(() => {
        findOperadores();
    }, []);

    const SIN_OPERADOR = {
        label: "SIN OPERADOR ASIGNADO",
        value: "SIN_OPERADOR"
    };

    // mezclamos operadores reales + opción extra
    const operadoresConSinAsignar = [SIN_OPERADOR, ...(operadores || [])];

    const onGridReady = (params) => 
    {
        params.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (params) => 
    {
        const columns = params.api.getColumns();

        const colsToAutoSize = columns
            .filter(col => {
            const def = col.getColDef();
            return !col.isPinned() && !def.cellRenderer;
            })
            .map(col => col.getColId());
            
        params.api.autoSizeColumns(colsToAutoSize, true);
    };

    const handleSubmit = async (e) => 
    {
        //e.preventDefault();
        let fechainicial = null, fechafinal = null, unidad = null, operador = null;
        if (startDate && startDate.$d!='Invalid Date')
            fechainicial = startDate.$d.toJSON().substring(0, 10);
        if (endDate && endDate.$d!='Invalid Date')
            fechafinal = endDate.$d.toJSON().substring(0, 10);
        if (unit && unit != 'undefined' && unit != '')
            unidad = unit;
        if (driver && driver != 'undefined' && driver != '')
            operador = driver;
        // Llamamos a fetchData para cargar los datos
        await fetchData(unidad, fechainicial, fechafinal, operador);
    };

    useEffect(() => 
    {
        if (!info) 
            handleSubmit();
    }, [info]);

    const updateRow = (rowActualizada) => {
        setData(prev =>
            prev.map(r => {
                if (r.id !== rowActualizada.id) return r;

                const mergedRow = {
                    ...r,
                    ...rowActualizada,
                };

                return {
                    ...mergedRow
                };
            })
        );
    };

    const handleCellClick = (event) => 
    {
        const colId = event?.column?.getColId?.();
        if (colId === 'actions' || colId === 'pdf') return;

        const rowData = event.data;
        const operador = rowData.driver?.split('-')[0].trim();
        const fecha_previa = rowData.fecha_previa_ok;
        const fecha_inicio = rowData.fecha_inicio_driver;
        const fecha_reset = rowData.date;

        let parametros = { startDate: startDate ? startDate.toISOString() : null, endDate: endDate ? endDate.toISOString() : null, driver, unit, operador, fecha_previa, fecha_inicio, fecha_reset, conWhere: 1 }

        let info = JSON.stringify(parametros);

        navigate('/diesel/omni/detalle', { state: { info: info } });
    };

    const handleVerTodoOmni = () => 
    {
        const parametros = {
            startDate: startDate ? startDate.toISOString() : null,
            endDate: endDate ? endDate.toISOString() : null,
            driver,
            unit
        };

        navigate('/diesel/omni/detalle', { state: { info: JSON.stringify(parametros) } });
    };

    const generarCartaPDFOperador = async () => 
    {
        try {

            if (!driver) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Selecciona un operador',
                });
                return;
            }

            const response = await myApi.post(
                '/omni/pdfCartaRendimiento',
                {
                    operador: driver,
                    unidad: unit || null,
                    fi: startDate
                        ? startDate.format('YYYY-MM-DD')
                        : null,
                    ff: endDate
                        ? endDate.format('YYYY-MM-DD')
                        : null,
                },
                {
                    responseType: 'blob',
                }
            );

            const blob = new Blob(
                [response.data],
                {
                    type: 'application/pdf',
                }
            );

            const url = window.URL.createObjectURL(blob);

            window.open(url, '_blank');

        } catch (error) {

            console.error(error);

            Swal.fire({
                icon: 'error',
                title: 'Error generando PDF',
            });
        }
    };

    return (
        <>
        <Paper
            sx={{
                p: 2,
                height: "100%",          // <-- clave
                width: "100%",            // <-- clave
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",       // ok, pero con layout correcto ya no “corta” paginación
                minHeight: 0,            // ✅ nuevo
                boxSizing: "border-box", // ✅ nuevo
            }}
        >
            <Box sx={{ flexShrink: 0 }}>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Grid container>
                        <Grid size={{ xs: 12, md: 8 }}>
                            <Typography variant="h4" fontWeight={700}>
                                <Box component="span" color="primary.main">
                                    Omnitracs
                                </Box>
                            </Typography>
                        </Grid>
                        <Grid container spacing={2} alignItems="center">
                            {/* Campo de Unidad */}
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Unidad"
                                    variant="outlined"
                                    value={unit}
                                    onChange={handleChangeUnidad}
                                    fullWidth
                                />
                            </Grid>
                            {/* Campo de Operador */}
                            <Grid item xs={12} sd={4}>
                                <Autocomplete
                                    multiple
                                    freeSolo
                                    options={operadoresConSinAsignar}
                                    getOptionLabel={(option) => {
                                        // Si es string (valor escrito), usarlo directamente
                                        if (typeof option === 'string') return option.toUpperCase();
                                        return (option?.label || '').toUpperCase();
                                    }}
                                    value={driver.map(val => {
                                        // Convertimos los valores guardados en objetos o strings
                                        const match = operadoresConSinAsignar.find(p => p.value === val);
                                        return match || val; 
                                    })}
                                    onChange={(event, newValue) => {
                                        // Guardamos solo los valores (string o value de objeto)
                                        const valores = newValue.map(v => (typeof v === 'string' ? v : v.value));
                                        setDriver(valores);
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        // Si value es string, comparar con option.value o option directamente
                                        if (typeof value === 'string') return option.value === value;
                                        return option.value === value.value;
                                    }}
                                    renderOption={(props, option) => (
                                        <li {...props}>{typeof option === 'string' ? option.toUpperCase() : (option.label || '').toUpperCase()}</li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Operador"
                                            variant="outlined"
                                            sx={{
                                            width: 'auto',
                                            minWidth: 200,
                                            maxWidth: '100%',
                                            '& .MuiInputBase-input': {
                                                whiteSpace: 'nowrap',
                                                overflow: 'visible',
                                                textOverflow: 'unset',
                                                textTransform: 'uppercase',
                                            },
                                            }}
                                        />
                                    )}
                                    renderTags={(tagValue, getTagProps) =>
                                        tagValue.map((option, index) => {
                                            const label = typeof option === 'string' ? option.toUpperCase() : (option.label || '').toUpperCase();
                                            return <Chip key={index} label={label} {...getTagProps({ index })} />;
                                        })
                                    }
                                />
                            </Grid>
                            {/* Campo de Fecha Inicial */}
                            <Grid item xs={12} sm={4}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={startDate}
                                        onChange={handleChangeStartDate}
                                        format="MM/DD/YY"
                                        label="Fecha Inicial"
                                        fullWidth
                                    />
                                </LocalizationProvider>
                                <IconButton onClick={() => handleClearDate('fi')} aria-label="clear">
                                    <ClearIcon />
                                </IconButton>
                            </Grid>
                            {/* Campo de Fecha Final */}
                            <Grid item xs={12} sm={4}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={endDate}
                                        onChange={handleChangeEndDate}
                                        format="MM/DD/YY"
                                        label="Fecha Final"
                                        fullWidth
                                    />
                                </LocalizationProvider>
                                <IconButton onClick={() => handleClearDate('ff')} aria-label="clear">
                                    <ClearIcon />
                                </IconButton>
                            </Grid>
                            {/* Botón de Buscar */}
                            <Grid item xs={12} sm={4}>
                                <Button
                                    type="button"
                                    color="inherit"
                                    onClick={handleSubmit}
                                    variant="contained"
                                    startIcon={<ManageSearchIcon />}
                                    sx={{ color: "primary", fontWeight: "bold" }}
                                >
                                    Buscar
                                </Button>
{/*                                 <Button                                    
                                    type="button"
                                    color="inherit"
                                    onClick={() => handleOpenModal()}
                                    variant="contained"
                                    startIcon={<AddIcon />}
                                    sx={{ color: "primary", fontWeight: "bold" }}
                                >
                                    Agregar
                                </Button> */}
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Box>
            <div>
                <Dialog open={open} onClose={handleCloseDialog} sx={{
                    "& .MuiDialog-paper": {
                        width: "50vw",
                        height: "50vh",
                        maxWidth: "none",
                        resize: "both",
                        overflow: "hidden",
                    },
                    "& .MuiDialogContent-root": {
                        padding: 0,
                        height: "100%",
                        overflow: "auto",
                    },
                    "& .MuiDialog-paper::after": {
                        content: '""',
                        position: "absolute",
                        width: 16,
                        height: 16,
                        right: 0,
                        bottom: 0,
                        cursor: "nwse-resize",
                    }
                }} PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title">
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {Titulo}
                    </DialogTitle>
                    <DialogContent>
                        {isPdf ? (
                            <object
                                data={fileUrl}
                                type="application/pdf"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                }}
                            >
                            <p>Tu navegador no soporta la visualización de PDFs. Puedes <a href={fileUrl} target="_blank" rel="noopener noreferrer">ver el PDF aquí</a>.</p>
                            </object>
                        ) : isImage ? (
                            <img
                                src={fileUrl}
                                alt="Imagen"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain', 
                                }}
                            />
                        ) : (
                            <p>Este archivo no es un PDF ni una imagen compatible.</p>
                        )}
                    </DialogContent>
                </Dialog>        
            </div>
            {/* {LISTA DE OMNITRACS} */}
            <Box sx={{ width: '100%', mt: 2 }}>
            {/* Barrita de botones superior */}
            <Box sx={{ mb: 1, display: 'flex', gap: 1, alignItems: 'center' }}>
                <Tooltip title="¿Qué significan los colores?" arrow placement="right">
                <IconButton size="small" onClick={() => setOpenLegend(true)}>
                    <HelpOutlineIcon fontSize="small" />
                </IconButton>
                </Tooltip>

                <Button
                variant="outlined"
                startIcon={<ListIcon />}
                color="primary"
                onClick={() => handleVerTodoOmni()}
                >
                Ver Todo Omnitracs
                </Button>

                <Button
                variant="contained"
                color="error"
                startIcon={<PictureAsPdfIcon />}
                disabled={!driver || driver.length === 0}
                onClick={generarCartaPDFOperador}
                >
                GENERAR PDF
                </Button>
            </Box>

            {/* Contenedor AG-Grid con altura fija definida */}
            <div className="ag-theme-quartz" style={{ height: 'calc(100vh - 310px)', minHeight: '400px', width: '100%' }}>
                <AgGridReact
                rowData={data}
                columnDefs={columns}
                pagination={true}
                autoSizeStrategy={{
                    type: 'fitCellContents',
                    skipHeader: true,
                }}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                enableCellTextSelection={true}
                getRowClass={(params) => {
                    if (params.data?.INICIAL === 1) {
                    return classes.rowBlue;
                    }
                    return null;
                }}
                onCellClicked={handleCellClick}
                />
            </div>
            </Box>
        </Paper>
        <ColorLegendDialog
            open={openLegend}
            onClose={() => setOpenLegend(false)}
            classes={classes}
        />
        {/* {MODAL EDITAR/CREAR} */}
        <CrearEditarModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            refresh={fetchData}
            carga={selected}
            isEditing={isEditing}
            onUpdate={updateRow}
        />
        </>
    )
}

export default Cargas_Omni